import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';
import { Store } from '@/stores';

export default function useStateOfUserStatus(store: Store) {
  return useMapStoreStateToClientState(store, (store) => {
    const isLoggedIn = store.myAccountStore.loginPage.loginStore?.isLoggedIn;
    const isCompleted = store.appStore.user.isFetched('FETCH_USER') || store.appStore.user.hasError('FETCH_USER');
    const isAuthInitialized = !isLoggedIn || (isLoggedIn && isCompleted);
    return {
      isAuthInitialized,
      isCompleted,
      isLoading: store.appStore.user.isLoading('FETCH_USER'),
    };
  });
}
